import React, { useState } from "react";

import { Button, Divider, Row, Col } from "antd";
import { CommentOutlined, PlusOutlined } from "@ant-design/icons";

import TasksList from "../../../../components/quote/qtask/list";
import FormTask from "../task";

const CustomTasksList = (props) => {
    const [modalNewVisible, setModalNewVisible] = useState(false);

    const [task, setTask] = useState(null);

    const isModalActive = modalNewVisible;

    const onModalEdit = (record) => {
        setTask(record);
        setModalNewVisible(true);
    };

    return (
        <>
            {props.allowEdit && (
                <Row justify="end">
                    <div style={{ padding: 10 }}>
                        <Button
                            size="small"
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => setModalNewVisible(true)}
                            disabled={modalNewVisible}
                            loading={modalNewVisible}
                        >
                            New Tasks
                        </Button>
                    </div>
                </Row>
            )}

            <TasksList {...props} onModalEdit={onModalEdit} isModalActive={isModalActive} />

            {modalNewVisible && props.allowEdit && (
                <FormTask
                    visible={modalNewVisible}
                    handleCancel={() => {
                        setModalNewVisible(false);
                        setTask(null);
                    }}
                    id={props.quote.id}
                    type={props.type}
                    data={props.quote}
                    catlogs={props.catlogs}
                    task={task}
                />
            )}
        </>
    );
};

export default CustomTasksList;
